import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { roleWeight, type AppRole } from "./types";
export function ProtectedRoute({ children, minimumRole="viewer" }: { children: ReactNode; minimumRole?: AppRole }) {
 const { configured,loading,profile,session }=useAuth(); const location=useLocation();
 if(!configured) return <Navigate replace to="/configuration"/>;
 if(loading) return <section className="workspace"><p>Cargando sesión…</p></section>;
 if(!session||!profile) return <Navigate replace state={{from:location.pathname}} to="/login"/>;
 if(roleWeight[profile.role]<roleWeight[minimumRole]) return <Navigate replace to="/sin-acceso"/>;
 return children;
}
